import React from 'react'

class ReportViewer extends React.Component {
    state = {  } 
    render() { 
        return (
            <>
            <p>test</p>
            </>
        );
    }
}
 
export default ReportViewer;